<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Member Property Profile
      </div>
      <button
        class="ac-close-button"
        @click="toggleModal(false);"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">
            Maintenance
          </div>
          <SACInput
            placeholder="Maintenance"
            field="maintenance"
            :value="profile.maintenance"
            :change="changeQuestionnaireDetail"
            :error="errorObj.maintenanceError"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Built in
          </div>
          <SACInput
            placeholder="Year"
            field="homeYear"
            :value="profile.homeYear"
            :change="changeQuestionnaireDetail"
            :error="errorObj.homeAgeError"
          />
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="updateQuestionnaire()"
      >
        Update
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Updating member questionnaire"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import moment from 'moment';
import SACInput from '../../sac/SACInput.vue';
import SACDropdown from '../../sac/SACDropdown.vue';

export default {
  name: 'PropertyProfileForm',
  components: {
    Datepicker,
    ProcessOverlay,
    SACInput,
    SACDropdown,
  },
  props: {
    selectedProfile: Object,
    toggleModal: Function,
  },
  data() {
    const profile = structuredClone(this.selectedProfile);
    return {
      profile,
      errorObj: {},
      processing: false,
    };
  },
  methods: {
    changeQuestionnaireDetail(field, value) {
      this.profile = { ...this.profile, [field]: value };
    },
    validResponse() {
      const error = {};
      if (!this.profile.homeYear) {
        error.homeAgeError = 'Home Age is required.';
      }
      if (this.profile.maintenance && this.profile.maintenance.length > 20) {
        error.maintenanceError= '20 char limit';
      }
      this.errorObj = error;
      return Object.keys(this.errorObj).length === 0;
    },
    async updateQuestionnaire() {
      if (this.validResponse()) {
        this.processing = true;
        await this.$store.dispatch('updatePropertyProfile', {
          homeYear: this.profile.homeYear,
          maintenance: this.profile.maintenance,
          serviceAddressId: this.profile.serviceAddressId,
        });
        this.processing = false;
        this.toggleModal(false);
      }
    },
  },
};
</script>
